const SIZE = {
  XXSMALL: 'xxsmall',
  XSMALL: 'xsmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
};

const SIZES = Object.values(SIZE);

const TYPE = {
  DEFAULT: 'default',
  ERROR: 'error',
  GENERIC: 'generic',
  NEUTRAL: 'neutral',
  SUCCESS: 'success',
  WARNING: 'warning',
  ALERT: 'alert',
  DETERMINATE: 'determinate',
  INDETERMINATE: 'indeterminate',
  EMBEDDED: 'embedded',
  FULL: 'full',
  CARD: 'card',
  SINGLE: 'single',
  HIGHLIGHT: 'highlight',
};

const TYPES = Object.values(TYPE);

const BUTTON_TYPES = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset',
};

const HIERARCHY = {
  LOUD: 'loud',
  QUIET: 'quiet',
  TRANSPARENT: 'transparent',
};

const HIERARCHIES = Object.values(HIERARCHY);

const BORDER = {
  STANDARD: 'standard',
  ROUNDED: 'rounded',
  CORNER: 'corner',
};

const BORDERS = Object.values(BORDER);

const DIRECTION = {
  UP: 'up',
  DOWN: 'down',
  RIGHT: 'right',
  LEFT: 'left',
};

const DIRECTIONS = Object.values(DIRECTION);

const ALIGNMENT = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT_TOP: 'leftTop',
  RIGHT_TOP: 'rightTop',
  BOTTOM_RIGHT: 'bottomRight',
  BOTTOM_LEFT: 'bottomLeft',
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  LEFT: 'left',
  RIGHT: 'right',
  CENTERED: 'centered',
  CENTER: 'center',
};

const ALIGNMENTS = Object.values(BORDER);

const SHADOW = {
  FLAT: 'flat',
  ELEVATED: 'elevated',
  OUTLINE: 'outline',
};

const SHADOWS = Object.values(SHADOW);

const BACKGROUND = {
  LIGHT: 'light',
  DARK: 'dark',
};

const BACKGROUNDS = Object.values(BACKGROUND);

const MODIFIER = {
  INLINE: 'inline',
  BLOCK: 'block',
  FULLSCREEN: 'fullscreen',
  COMPLETED: 'completed',
  READONLY: 'readonly',
  CIRCLE: 'circle',
  SQUARE: 'square',
  ERROR: 'error',
};

const MODIFIERS = Object.values(MODIFIER);

const SELECTION_TYPE = {
  RANGE: 'range',
  SINGLE: 'single',
  MULTIPLE: 'multiple',
};

const SELECTION_TYPES = Object.values(SELECTION_TYPE);

const DISPLAY_MODE = {
  INLINE: 'inline',
  INPUT: 'input',
  MAXED: 'maxed',
  COMPACT: 'compact',
  FORM: 'form',
  STANDALONE: 'standalone',
  DROPDOWN: 'dropdown',
};

const DISPLAY_MODES = Object.values(DISPLAY_MODE);

const LOCALE = {
  ENGLISH: 'en',
  SPANISH: 'es',
  PORTUGUESE: 'pt',
};

const LOCALES = Object.values(LOCALE);

const COLOR = {
  WHITE: 'white',
  BLUE: 'blue',
  ACCENT: 'accent',
  GRAY: 'gray',
  GREEN: 'green',
  ORANGE: 'orange',
  RED: 'red',
};

const COLORS = Object.values(COLOR);

const TRIGGER = {
  HOVER: 'hover',
  CLICK: 'clicK',
  NO_TRIGGER: 'no-trigger',
};

const TRIGGERS = Object.values(TRIGGER);

const SITE = {
  MLA: 'MLA',
  MLB: 'MLB',
  MLM: 'MLM',
  MCO: 'MCO',
  MLC: 'MLC',
  MPE: 'MPE',
};

const SITES = Object.values(SITE);

const SORT = {
  ASCENDANT: 'asc',
  DESCENDANT: 'desc',
};

const SORTS = Object.values(SORT);

const DEVICE_TYPE = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};

const DEVICE_TYPES = Object.values(DEVICE_TYPE);

const LOGGER_CONTEXT = {
  CONTROLLER: 'controller',
  MIDDLEWARE: 'middleware',
  API_CONTROLLER: 'api/controller',
  API_MIDDLEWARE: 'api/middleware',
  SERVICE: 'service',
};

const LOGGER_EXECUTION = {
  STARTED: 'started',
  FAILED: 'failed',
  SUCCEEDED: 'succeeded',
};

const LOGGER_TRANSACTION = {
  STARTED: 'Transaction started',
  FAILED: 'Transaction failed',
  SUCCEEDED: 'Transaction succeeded',
};

const OPERATOR_PERMISSIONS = {
  WRITE: 'credits_write',
  READ: 'credits_read',
};

const MESSAGE_STATUS = {
  ERROR: TYPE.ERROR,
  WARNING: TYPE.WARNING,
  HIGHLIGHT: TYPE.HIGHLIGHT,
};

const CHECKBOX_STATE = {
  ALL: 'all',
  SOME: 'some',
  NONE: 'none',
};

const BUTTON_HIERARCHY = {
  LOUD: HIERARCHY.LOUD,
  QUIET: HIERARCHY.QUIET,
  TRANSPARENT: HIERARCHY.TRANSPARENT,
};

const NOTIFICATION_TYPE = {
  SUCCESS: TYPE.SUCCESS,
  WARNING: TYPE.WARNING,
  ALERT: TYPE.ALERT,
  ERROR: TYPE.ERROR,
};

const APP_TYPE = {
  API: 'api',
  APP: 'app',
};

const PLATFORM = {
  ML: 'ml',
  MP: 'mp',
};

const WEBKIT = {
  ENGINE: {
    V200: '2.0.0',
    LEGACY: 'legacy',
  },
};

const MOBILE_OS_NAME = {
  IOS: 'iOS',
  ANDROID: 'Android',
};

const CONTENT_TYPE = {
  ICON: 'icon',
  TEXT: 'text',
};

const WEIGHT = {
  REGULAR: 'regular',
  SEMIBOLD: 'semibold',
};

const APP_THEME = {
  YELLOW: 'yellowblue-light',
  CYAN: 'cyan-light',
};

module.exports = {
  BUTTON_HIERARCHY,
  CHECKBOX_STATE,
  DEVICE_TYPES,
  DEVICE_TYPE,
  DIRECTIONS,
  DIRECTION,
  LOGGER_CONTEXT,
  LOGGER_EXECUTION,
  LOGGER_TRANSACTION,
  OPERATOR_PERMISSIONS,
  MESSAGE_STATUS,
  NOTIFICATION_TYPE,
  SITES,
  SITE,
  SIZES,
  SIZE,
  TYPE,
  TYPES,
  HIERARCHY,
  HIERARCHIES,
  BORDER,
  BORDERS,
  ALIGNMENT,
  ALIGNMENTS,
  SHADOW,
  SHADOWS,
  BACKGROUND,
  BACKGROUNDS,
  MODIFIER,
  MODIFIERS,
  SELECTION_TYPE,
  SELECTION_TYPES,
  DISPLAY_MODE,
  DISPLAY_MODES,
  LOCALE,
  LOCALES,
  COLOR,
  COLORS,
  SORT,
  SORTS,
  TRIGGER,
  TRIGGERS,
  BUTTON_TYPES,
  APP_TYPE,
  PLATFORM,
  WEBKIT,
  MOBILE_OS_NAME,
  CONTENT_TYPE,
  WEIGHT,
  APP_THEME,
};
